import script from "./ProyectoN2DatosGenerales.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProyectoN2DatosGenerales.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__